import { getBadgeClass } from "./badge.styles";
import type { BadgeProps } from "./badge.types";

export const Badge = ({ children, variant = "primary", size = "md", className }: BadgeProps) => (
  <span className={getBadgeClass({ variant, size, className })}>{children}</span>
);
